import React, { useEffect, useState } from 'react';

type AgentLayoutContextValue = {
	sidebar: boolean;
	setSidebar: (value: boolean) => void;
	mobileSidebar: boolean;
	setMobileSidebar: (value: boolean) => void;
};
const AgentLayoutContext = React.createContext<AgentLayoutContextValue>(null);
const storageKey = 'agent-sidebar-open';

const AgentLayoutProvider = ({ children }) => {
	const [sidebar, setSidebarState] = useState(true);
	const [mobileSidebar, setMobileSidebar] = useState(false);
	useEffect(() => {
		const saved = window.localStorage.getItem(storageKey);
		if (saved !== null) setSidebarState(saved === 'true');
	}, []);
	const setSidebar = value => {
		setSidebarState(value);
		window.localStorage.setItem(storageKey, String(value));
	};
	return (
		<AgentLayoutContext.Provider value={{ sidebar, setSidebar, mobileSidebar, setMobileSidebar }}>
			{children}
		</AgentLayoutContext.Provider>
	);
};
const useAgentLayout = () => React.useContext(AgentLayoutContext);
export { AgentLayoutProvider, useAgentLayout };
